import { Button, Form, Input, message, Typography } from "antd";
import logo from "../../assets/images/sord_logo_transparent.png";
import styles from "./ForgetPassword.module.scss";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";

const { Text, Title } = Typography;
const ForgetPassword = () => {
  const navigate = useNavigate();

  const onFinish = (values) => {
    navigate("/login");
    message.success("Password reset successfully!");
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <img
            src={logo}
            alt="logo"
            className={styles.logo}
            onClick={() => navigate("/")}
          />
          <Title className={styles.title}>Forget Password</Title>
          <Text className={styles.text}>
            Welcome back to Radar+! Please enter your email address on old
            password to set a new password.
          </Text>
        </div>
        <Form
          name="forget_password_recovery_form"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          layout="vertical"
          requiredMark="optional"
        >
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Email" />
          </Form.Item>
          <Form.Item
            name="old_password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              type="password"
              placeholder="Old Password"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your new password!",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              type="password"
              placeholder="New Password"
            />
          </Form.Item>
          <Form.Item
            name="confirm_password"
            rules={[
              {
                required: true,
                message: "Please input your new password!",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              type="password"
              placeholder="Confirm Password"
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: "0px" }}>
            <Button block="true" type="primary" htmlType="submit">
              Reset Password
            </Button>
            <div className={styles.footer}>
              <Text className={styles.text}>Remember your password ?</Text>{" "}
              <Link to="/login">Sign in</Link>
            </div>
          </Form.Item>
        </Form>
      </div>
    </section>
  );
};
export default ForgetPassword;
